<template>
  <el-popover
    v-if="!isStudentDownstageCDN"
    placement="top-start"
    trigger="hover"
    popper-class="layout-popover"
    v-model="layoutVisible"
  >
    <div class="layout-list">
      <div
        class="layout-item"
        v-for="item in layoutList"
        :key="item.value"
        @click="handleLayoutChange(item)"
      >
        <img v-if="layout === item.value" :src="item.imgSelect" alt="" />
        <img v-else :src="item.img" alt="" />
        <div class="label">{{ item.name }}</div>
        <div class="suggest" v-if="isShowSuggest(item)">
          <img src="@saas/pages/assets/images/live/tuijian.png" alt="" />
        </div>
      </div>
    </div>
    <div class="menu-item grid" slot="reference">
      <img
        class="layout-icon"
        src="@saas/pages/assets/images/live/grid.png"
        alt=""
      />
      <span>布局</span>
    </div>
  </el-popover>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import {
  getRoster,
  updateRoomStatus,
  setUserRole,
  removeUser,
  getRoomInfo,
} from "@saas/service-api/src/live-sdk";
export default {
  data() {
    return {
      layoutVisible: false,
      layoutList: [
        {
          name: "顶部栏",
          value: "horizontal",
          img: require("@saas/pages/assets/images/live/layout-horizontal.png"),
          imgSelect: require("@saas/pages/assets/images/live/layout-horizontal-select.png"),
        },
        {
          name: "侧边栏",
          value: "vertical",
          img: require("@saas/pages/assets/images/live/layout-vertical.png"),
          imgSelect: require("@saas/pages/assets/images/live/layout-vertical-select.png"),
        },
        {
          name: "演讲者",
          value: "speaker",
          img: require("@saas/pages/assets/images/live/layout-speaker.png"),
          imgSelect: require("@saas/pages/assets/images/live/layout-speaker-select.png"),
        },
      ],
    };
  },
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "microphoneList",
      "speakerList",
      "layout",
      "roomInfo",
      "whiteBoardService",
      "userStatus",
      "imService",
      "isRecordPage",
    ]),
    // 1 大班课 2小班课
    roomType() {
      return this.roomInfo.room_type;
    },
    // 几v几
    goodsRoomType() {
      return this.roomInfo.goods_room_type;
    },
    // 判断是否为大班课学生下台使用CDN流的情况
    isStudentDownstageCDN() {
      return (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      );
    },
  },
  methods: {
    ...mapMutations("live", ["setLayout", "setOnlineCount", "setIsDelay"]),
    // 布局切换
    handleLayoutChange(layout) {
      uploadLiveLog({
        message: "用户点击布局切换",
        extra: {
          component: "LayoutPopover",
          action: "click_layout_change",
          layoutValue: layout.value,
          layoutName: layout.name,
          currentLayout: this.layout,
        },
      });

      if (this.roomInfo.isTeacher) {
        const map = {
          horizontal: 1,
          vertical: 2,
          speaker: 3,
        };
        updateRoomStatus({
          id: this.roomInfo.id,
          live_layout: map[layout.value],
        })
          .then((res) => {
            if (res.code === 1) {
              this.setLayout(layout.value);
              // this.imService.sendMGLiveRoomCustomMsg({
              //   cmdId: 2,
              //   data: {
              //     type: "layoutChange",
              //     data: {
              //       value: map[layout.value],
              //     },
              //   },
              // });
            } else {
              this.$darkMessage.error(res.message);
              uploadLiveLog({
                message: "布局切换失败",
                extra: {
                  component: "LayoutPopover",
                },
              });
            }
          })
          .catch((err) => {
            this.$darkMessage.error("布局切换失败");
            uploadLiveLog({
              message: "布局切换失败",
              extra: {
                component: "LayoutPopover",
              },
            });
          });
      } else {
        this.updateLayout(layout);
      }
    },
    // 更新布局
    updateLayout(layout) {
      this.setLayout(layout.value);
      this.layoutVisible = false;
      setTimeout(() => {
        // 白板大小重置
        if (this.whiteBoardService?.resizeBoard) {
          this.whiteBoardService.resizeBoard();
        }
      }, 200);
    },
    isShowSuggest(item) {
      if (item.value === "vertical") {
        return false;
      }
      if (item.value === "speaker") {
        // TODO 小班课并且1v1也是true
        if (
          this.roomType === 1 ||
          (this.roomType === 2 && this.goodsRoomType === 1)
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (item.value === "horizontal") {
        if (
          this.roomType === 1 ||
          (this.roomType === 2 && this.goodsRoomType === 1)
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-icon {
  width: 20px;
  height: 20px;
}
.menu-item {
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  margin-left: 12px;
  -webkit-app-region: none;
  img {
    width: 20px;
    height: 20px;
  }
  span {
    margin-left: 3px;
    font-weight: 400;
    font-size: 12px;
    color: #c9cdd4;
  }
}
.layout-list {
  width: 249px;
  height: 85px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  .layout-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    .suggest {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 0;
      top: 28px;
      img {
        width: 100%;
        height: 100%;
        border-radius: none !important;
      }
    }
    img {
      width: 58px;
      height: 44px;
      border-radius: 4px;
    }
    .label {
      font-weight: 500;
      font-size: 14px;
      color: #ecedee;
      line-height: 16px;
      margin-top: 10px;
    }
    &:hover {
      img {
        border: 1px solid #006fee;
      }
      .suggest {
        img {
          border: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.layout-popover {
  background: #1e1e20;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(229, 231, 235, 0.04) !important;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8) !important;
  padding: 0;
  .popper__arrow {
    display: none;
  }
}
</style>
